<script lang="ts">
  import type { ProgressStepContext } from "@kontextwerk/web-sdk/ui/navigation/ProgressSteps.svelte"
  import type { DemoDataResetMembershipCandidate } from "../../../../../../../../../../../../../../api/kehrblatt/demo-data"
  import type { DemoResetMemberOutput } from "../../_shared/_logic/demo-data-reset-contract"
  import DemoMemberStep from "../../_shared/_modules/demo-member-step"

  const {
    ctx,
    candidates,
    initialMembershipId = null,
    loading = false,
    loadError = "",
    onRetry,
    output = null,
    onOutput,
    onEdit,
  }: {
    ctx: ProgressStepContext
    candidates: readonly DemoDataResetMembershipCandidate[]
    initialMembershipId?: string | null
    loading?: boolean
    loadError?: string
    onRetry: () => void
    output?: DemoResetMemberOutput | null
    onOutput: (output: DemoResetMemberOutput) => void
    onEdit: () => void
  } = $props()
</script>

<DemoMemberStep
  {ctx}
  role="primary"
  title="Chef auswählen"
  description="Wählen Sie das bestehende Mitglied, das im Testzugang als Chef auftritt."
  helpModalTextId="organizationTestDataChef"
  actionBoxLabel="Mitglied für den Chef"
  roleDescription="Der Chef betreut die erste Hälfte der Beispiel-Liegenschaften. Zugang, Rolle und Passwort des Mitglieds bleiben unverändert."
  emptyMessage="Diese Organisation hat keine aktiven Mitglieder."
  {candidates}
  {initialMembershipId}
  {loading}
  {loadError}
  {onRetry}
  {output}
  {onOutput}
  {onEdit}
/>
